__turbopack_context__.v({
  "container": "FileUploadGallery-module-scss-module__xaP_cq__container",
  "dragged": "FileUploadGallery-module-scss-module__xaP_cq__dragged",
});
